<template>
  <div class="helpbody">
    <div class="titlelist" v-for="(t,i) in titles" :key="'t'+i" @click="toDetail(i)">{{t}}</div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      titles: ["激活帮助","账号问题","驾驶出行","ADAS安全辅助","信息娱乐","APP使用问题","车辆升级","用电安全","车辆保养","故障自检"],
    }
  },
  mounted(){
    document.title = "帮助中心"
  },
  methods: {
    toDetail(i){
      this.$router.push("/bs/help/"+(i+1))
    }
  }
}
</script>

<style lang="less" scoped>
.helpbody{
  height: 100%;
  box-sizing: border-box;
  background: #111117;  
  .titlelist{    
    color: #fff;
    line-height: 50px;
    height: 50px;
    position: relative;
    background: #1A1A1F;
    padding-left: 32px;
  }
  .titlelist::before{
    content: "";
    width: 7px;
    height: 7px;
    border-top: 1px solid #999;
    border-right: 1px solid #999;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    right: 40px;
    transform: rotate(45deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/help/home.vue